// eslint-disable-next-line import/prefer-default-export
export const SideMenuTabs = {
  ToggleMenu: 0,
  Contact: 1,
  Shopify: 3,
  ChatBot: 4,
  Fluentlab: 5,
  WsCatalogue: 6,
};
